import styled from 'styled-components';
import SubHeader from '../components/sub/SubHeader';
import SubVisual from '../components/sub/SubVisual';
import { flexColumn, flexNoneEnd, flexCenterCenter, flexNoneStart } from '../styles/mixins.style';
import subVisualReservation from '../img/sub/sub_visual_reservation.jpg';
import subVisualReservationMb from '../img/sub/sub_visual_reservation_mb.jpg';
import useScrollFadeIn from '../hooks/useScrollFadeIn';
import { FadeInDiv } from '../styles/fadeIn';
import React, { useState, useEffect } from 'react';


export default function Reservation() {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	// 각 SectionContainer별 fade 훅 선언
	const fadeSection1 = useScrollFadeIn();
	const fadeSection2 = useScrollFadeIn();
	const fadeSection3 = useScrollFadeIn();
	const fadeSection4 = useScrollFadeIn();
	// 공간 이용안내 모바일용 개별 fade 훅들
	const fadeSpaceTitle = useScrollFadeIn();
	const fadeSpace1F = useScrollFadeIn();
	const fadeSpace2F = useScrollFadeIn();
	const fadeSpace25F = useScrollFadeIn();
	const fadeSpace3F = useScrollFadeIn();
	return (
		<ReservationLayout>
			<SubHeader />
			<SubVisual
				image={isMobile ? subVisualReservationMb : subVisualReservation}
				title="예약안내 및 당부의 말씀"
				subtitle={
					<>
						예약 시 모든 주의사항에 동의한 것으로 간주되며,<br className="mobile-br" /> 지내시는 동안 불편함이 없도록 <br className="mobile-br" />최선을 다하겠습니다.
					</>
				}
			/>
			<FadeInDiv ref={fadeSection1.ref} $visible={fadeSection1.visible}>
				<SectionContainer>
					<SectionContent>
						<Title>기본 안내</Title>
						<SectionDesc>
							<p>
								기준인원 2인 / 최대인원 4인 <br />
								→ 성인 2인 유·아동(0세부터)2인 / 성인3인 유·아동1인 <br />
								→ 성인 (혼성)4인 입실 불가 / 혼성 투숙 예시) 여성2인+남성2인 등 <br />
								→ 여성 4인 or 남성 4인 가능
							</p>
							<p>실내외 모든 시설물(소품/가구/식기/침구)의 훼손, 파손, 분실 시 동일제품 구매가격이 청구됩니다.</p>
							<p>보호자 미동반 미성년자는 입실이 불가합니다.</p>
							<p>반려견 및 반려묘와 동반 투숙이 불가합니다.</p>
							<p>체크인 15:00시 / 체크아웃 11:00시 (다음 투숙객을 위해 얼리체크인/레이트체크아웃은 불가한 점 양해 부탁드립니다)</p>
							<p>숙소 내 절대 금연(흡연 시 청소비용 및 위약금 <span style={{fontWeight:600}}>25만원</span> 발생)입니다.</p>
							<p>객실 내 냄새가 강한 음식(생선, 고기, 튀김 등) 요리는 불가합니다(위반 시 청소비용 발생).</p>
							<p>실내외 바닥 단차가 많으니 보행에 주의하시기 바라며, 부주의로 인한 사고는 투숙객에게 책임이 있습니다. </p>
							<p>방법 및 입장인원 확인을 위해 건물 외부 및 마당에 CCTV가 설치되어 있습니다. </p>
							<p>예약인원 외 인원 추가 및 지인 방문 등은 퇴실 및 미 환불 조치되며 이에 따른 책임은 투숙객에게 있습니다. </p>
							<p className="red">어촌에 위치해 있어 벌레,곤충 등이 나타날 수 있으며, 이로 인한 환불은 불가 하오니 예약 전 참고 바랍니다.</p>
							<p className="red">어린이 동반 투숙객은 아래 케어키즈존 안내란을 꼭 확인하시어 이용에 착오가 없으시길 바랍니다.</p>
						</SectionDesc>
					</SectionContent>
				</SectionContainer>
			</FadeInDiv>
			<FadeInDiv ref={fadeSection2.ref} $visible={fadeSection2.visible}>
				<SectionContainer $marginTop="40px">
					<SectionContent>
						<Title>어린이 투숙객을 위한 배려</Title>
						<SectionDesc>
							호리굴에 방문하는 모든 아이들이 마냥 즐겁게 지내길 바라며 아이들을 위한 용품이 구비되어 있습니다.
						</SectionDesc>
						<Row>
							<Col>
								<p>부가부 지라프 하이체어 </p>
								<p>타가 트래블키트 4종세트 </p>
							</Col>
							<Col>
								<p>탁가온 유아식기</p>
								<p>아동용 튜브 </p>
							</Col>
							<Col>
								<p>키즈 가운(4-7세용)</p>
								<p>야외용 슬리퍼</p>
							</Col>
						</Row>
					</SectionContent>
				</SectionContainer>
			</FadeInDiv>
			<FadeInDiv ref={fadeSection3.ref} $visible={fadeSection3.visible}>
				<SectionContainer $marginTop="40px">
					<SectionContent>
						<Title>케어키즈존</Title>
						<SectionDesc>
							스테이 호리굴은 케어키즈존 입니다.
						</SectionDesc>
						<Row $gap="8rem" $marginTop="2rem">
							<Col $minWidth="250px">
								<p>실내외 바닥 단차가 많으니 보행에 주의하시기 바랍니다.</p>
								<p>13세 미만의 어린이는 사우나 이용을 삼가 바랍니다.</p>
								<p>모서리 부딪힘 등 기타 안전사고에 각별히 유의하시기 바랍니다. </p>
								<p>안전관리 소홀 및 부주의에 의한 사고의 책임은 보호자에게 있습니다.</p>
							</Col>
							<Col $minWidth="250px">
								<p>자쿠지 및 실외 수영장에서 성인이 함께 사용하시길 바랍니다.</p>
								<p>실내외 모든 시설물(소품/가구/식기/침구)의 훼손, 파손, 분실 시 동일제품 구매가격을 청구 드립니다. </p>
								<p>
									오염 사례가 빈번한 아이들의 <span style={{ fontWeight: 500 }}>크레용, 물감, 슬라임 놀이</span> 등은 금해주시기 바랍니다.
								</p>
							</Col>
						</Row>
					</SectionContent>
				</SectionContainer>
			</FadeInDiv>
			{isMobile ? (
				<>
					<FadeInDiv ref={fadeSpaceTitle.ref} $visible={fadeSpaceTitle.visible}>
						<SectionContainer $marginTop="40px">
							<SectionContent>
								<Title>공간 이용안내</Title>
							</SectionContent>
						</SectionContainer>
					</FadeInDiv>
					<FadeInDiv ref={fadeSpace1F.ref} $visible={fadeSpace1F.visible}>
						<SectionContainer $marginTop="20px">
							<SectionContent>
								<div>
									<BoxLabel>1F 자쿠지 & 사우나</BoxLabel>
									<BoxDesc>
										<p>자쿠지 물을 가득 채우는데 약 2시간이 소요됩니다. </p>
										<p>자쿠지 이용 시 제공되는 입욕제만 사용해 주세요. </p>
										<p>자쿠지 이용 후 마개를 제거하여 물을 배수해 주세요. </p>
										<p>나무 및 식물에 뜨거운 물을 뿌리거나 닿지 말아 주세요. 식물이 죽을 수 있습니다. </p>
										<p>미끄러움에 주의해 주세요. </p>
										<p>건식 사우나입니다. 사우나 기기의 돌에 물을 뿌리지 말아주세요. 고장의 원인이 됩니다. </p>
									</BoxDesc>
								</div>
							</SectionContent>
						</SectionContainer>
					</FadeInDiv>
					<FadeInDiv ref={fadeSpace2F.ref} $visible={fadeSpace2F.visible}>
						<SectionContainer $marginTop="20px">
							<SectionContent>
								<div>
									<BoxLabel>2F 키친 & 다이닝</BoxLabel>
									<BoxDesc>
										<p>유리 난간에 기대지 마세요</p>
										<p>냄새가 강한 음식 요리가 불가합니다. 위반시 청소비용이 발생합니다.</p>
										<p>테이블에 뜨거운 냄비 등을 직접적으로 올리지 마시고, 냄비 받침을 이용 바랍니다.</p>
									</BoxDesc>
								</div>
							</SectionContent>
						</SectionContainer>
					</FadeInDiv>
					<FadeInDiv ref={fadeSpace25F.ref} $visible={fadeSpace25F.visible}>
						<SectionContainer $marginTop="20px">
							<SectionContent>
								<div>
									<BoxLabel>2.5F 야외 바비큐</BoxLabel>
									<BoxDesc>
										<p>야외용 식기를 이용 바랍니다. 2층 키친 & 다이닝에 구비되어 있습니다.</p>
										<p>야외용 슬리퍼를 필히 착용 바랍니다. </p>
										<p>미끄러움에 주의해 주세요.</p>
										<p>호리굴의 모든 공간은 금연 구역입니다. 옥상 야외에서도 흡연을 금해주시기 바랍니다.</p>
									</BoxDesc>
								</div>
							</SectionContent>
						</SectionContainer>
					</FadeInDiv>
					<FadeInDiv ref={fadeSpace3F.ref} $visible={fadeSpace3F.visible}>
						<SectionContainer $marginTop="20px">
							<SectionContent>
								<div>
									<BoxLabel>3F 루프탑 수영장 & 샤워</BoxLabel>
									<BoxDesc>
										<p>가로5M 세로2.3M 수심1M입니다.</p>
										<p>우천시에도 이용이 가능합니다.</p>
										<p>
											온수는 입실 당일 22시까지 35~36도 유지됩니다. <br />
											→ 계절에 따라 온수 온도는 상이 할 수 있으며, 문의 시 개별적으로 안내해 드립니다. <br />
											→ 온수 신청 후 입실 시 수영장을 사용하지 않더라도 온수 비용은 환불이 불가합니다.
										</p>
										<p>수영장 평상은 물놀이를 하면서 이용하는 공간으로 물기가 많은 점 미리 고지해 드립니다.</p>
										<p>수영장 평상에는 젖으면 안되는 물품(전자기기) 등을 올려 놓지 마시기 바랍니다.</p>
										<p>36개월 이하의 어린이는 반드시 물놀이용 기저귀를 착용해 주세요.</p>
										<p>수영장 내에서 음식물 섭취 및 음주는 불가합니다.</p>
										<p>야외 샤워 수전 이용 시 비누를 사용하지 않는 간단한 물샤워 바랍니다.</p>
										<p>
											장난감, 입욕제, 작은 입자의 물품 등은 수영장 시설의 고장의 원인이 될 수 있습니다. <br />
											→ 시설장비 고장 시 시설물 관리에 따른 책임배상이 청구될 수 있습니다.
										</p>
										<p>미끄러움에 주의해 주세요.</p>
										<p>안전사고에 각별히 유의해 주시기 바라며, 부주의로 인한 사고는 투숙객에게 책임이 있습니다.</p>
										<p>수영장 바닥의 마개 및 각종 마개를 임의로 제거하지 마세요. 수영장 물이 모두 빠져 사용이 불가해 집니다.</p>
									</BoxDesc>
								</div>
							</SectionContent>
						</SectionContainer>
					</FadeInDiv>
				</>
			) : (
				<FadeInDiv ref={fadeSection4.ref} $visible={fadeSection4.visible}>
					<SectionContainer $marginTop="40px">
						<SectionContent>
							<Title>공간 이용안내</Title>
							<div style={{ display: 'flex', flexDirection: 'column', gap: '40px', marginTop: '20px' }}>
								<div>
									<BoxLabel>1F 자쿠지 & 사우나</BoxLabel>
									<BoxDesc>
										<p>자쿠지 물을 가득 채우는데 약 2시간이 소요됩니다. </p>
										<p>자쿠지 이용 시 제공되는 입욕제만 사용해 주세요. </p>
										<p>자쿠지 이용 후 마개를 제거하여 물을 배수해 주세요. </p>
										<p>나무 및 식물에 뜨거운 물을 뿌리거나 닿지 말아 주세요. 식물이 죽을 수 있습니다. </p>
										<p>미끄러움에 주의해 주세요. </p>
										<p>건식 사우나입니다. 사우나 기기의 돌에 물을 뿌리지 말아주세요. 고장의 원인이 됩니다. </p>
									</BoxDesc>
								</div>
								<div>
									<BoxLabel>2F 키친 & 다이닝</BoxLabel>
									<BoxDesc>
										<p>유리 난간에 기대지 마세요</p>
										<p>냄새가 강한 음식 요리가 불가합니다. 위반시 청소비용이 발생합니다.</p>
										<p>테이블에 뜨거운 냄비 등을 직접적으로 올리지 마시고, 냄비 받침을 이용 바랍니다.</p>
									</BoxDesc>
								</div>
								<div>
									<BoxLabel>2.5F 야외 바비큐</BoxLabel>
									<BoxDesc>
										<p>야외용 식기를 이용 바랍니다. 2층 키친 & 다이닝에 구비되어 있습니다.</p>
										<p>야외용 슬리퍼를 필히 착용 바랍니다. </p>
										<p>미끄러움에 주의해 주세요.</p>
										<p>호리굴의 모든 공간은 금연 구역입니다. 옥상 야외에서도 흡연을 금해주시기 바랍니다.</p>
									</BoxDesc>
								</div>
								<div>
									<BoxLabel>3F 루프탑 수영장 & 샤워</BoxLabel>
									<BoxDesc>
										<p>가로5M 세로2.3M 수심1M입니다.</p>
										<p>우천시에도 이용이 가능합니다.</p>
										<p>
											온수는 입실 당일 22시까지 35~36도 유지됩니다. <br />
											→ 계절에 따라 온수 온도는 상이 할 수 있으며, 문의 시 개별적으로 안내해 드립니다. <br />
											→ 온수 신청 후 입실 시 수영장을 사용하지 않더라도 온수 비용은 환불이 불가합니다.
										</p>
										<p>수영장 평상은 물놀이를 하면서 이용하는 공간으로 물기가 많은 점 미리 고지해 드립니다.</p>
										<p>수영장 평상에는 젖으면 안되는 물품(전자기기) 등을 올려 놓지 마시기 바랍니다.</p>
										<p>36개월 이하의 어린이는 반드시 물놀이용 기저귀를 착용해 주세요.</p>
										<p>수영장 내에서 음식물 섭취 및 음주는 불가합니다.</p>
										<p>야외 샤워 수전 이용 시 비누를 사용하지 않는 간단한 물샤워 바랍니다.</p>
										<p>
											장난감, 입욕제, 작은 입자의 물품 등은 수영장 시설의 고장의 원인이 될 수 있습니다. <br />
											→ 시설장비 고장 시 시설물 관리에 따른 책임배상이 청구될 수 있습니다.
										</p>
										<p>미끄러움에 주의해 주세요.</p>
										<p>안전사고에 각별히 유의해 주시기 바라며, 부주의로 인한 사고는 투숙객에게 책임이 있습니다.</p>
										<p>수영장 바닥의 마개 및 각종 마개를 임의로 제거하지 마세요. 수영장 물이 모두 빠져 사용이 불가해 집니다.</p>
									</BoxDesc>
								</div>
							</div>
						</SectionContent>
					</SectionContainer>
				</FadeInDiv>
			)}
			<NaverReserveButton
				href="https://booking.naver.com/booking/3/bizes/1405798/items/6725690?area=ple&lang=ko&theme=place"
				target="_blank"
				rel="noopener noreferrer"
			>
				네이버 예약 바로가기
			</NaverReserveButton>
		</ReservationLayout>
	);
}

const ReservationLayout = styled.div`
	margin-left: 250px;
	@media (max-width: 1024px) {
		margin-left: 0;
	}
`;

const SectionContainer = styled.div<{$marginTop?: string}>`
	font-family: 'Pretendard', sans-serif;
	width: 95%;
	background: rgba(255,255,255,0.15);
	border-radius: 16px;
	margin-top: ${({ $marginTop }) => $marginTop || '0'};
	padding: 2.25rem 2.5rem;
	@media (max-width: 1024px) {
		width: 95%;
		margin: ${({ $marginTop }) => $marginTop || '0'} auto 0 auto;
	}
	@media (max-width: 768px) {
		background: transparent;
		padding: 0;
		width: 95%;
		margin: ${({ $marginTop }) => $marginTop || '0'} auto 0 auto;
	}
`;

const SectionContent = styled.div`
`;

const Title = styled.div`
	font-family: 'MaruBuri', sans-serif;
	font-weight: 600;
	font-size: 1.25rem;
	color: #fff;
	@media (max-width: 768px) {
		font-size: 1.125rem;
		position: relative;
		padding-left: 0.825rem;
		&::before {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			top: 0.1em;
			width: 3px;
			height: 1.3rem;
			background: #fff;
		}
	}
`;

const SectionDesc = styled.div`
	font-size: 1rem;
	color: rgba(255,255,255,0.7);
	line-height: 2rem;
	margin-top: 0.6875rem;
	p {
		margin: 0 0 0 0;
		font-weight: 200;
		position: relative;
		padding-left: 1.1em;
		&::before {
			content: '·';
			position: absolute;
			left: 0;
			top: 0;
			color: rgba(255,255,255,0.7);
			font-size: 2em;
			line-height: inherit;
		}
		&.red {
			color: #F26060;
			font-weight: 500;
			padding-left: 1.1em;
			&::before {
				content: '※';
				color: #F26060;
				font-size: 1rem;
			}
		}
		@media (max-width: 768px) {
			font-size: 0.875rem;
			line-height: 1.5rem;
		}
	}
`;

const Row = styled.div<{$gap?: string, $marginTop?: string}>`
	${flexNoneStart} 
	gap: ${({ $gap }) => $gap || '32px'};
	margin-top: ${({ $marginTop }) => $marginTop || '1rem'};
	@media (max-width: 1024px) {
		flex-direction: column;
		gap: 0;
	}
`;

const Col = styled.div<{$minWidth?: string}>`
	${flexColumn}
	min-width: ${({ $minWidth }) => $minWidth || '180px'};
	p {
		color: rgba(255,255,255,0.7);
		font-weight: 200;
		line-height: 1.5rem;
		margin-bottom: 0.5rem;
		position: relative;
		padding-left: 1.1em;
		&::before {
			content: '·';
			position: absolute;
			left: 0;
			top: 0;
			color: rgba(255,255,255,0.7);
			font-size: 2em; 
			line-height: inherit;
		}
		@media (max-width: 768px) {
			font-size: 0.875rem;
			line-height: 1.5rem;
		}
	}
`;

const BoxLabel = styled.div`
	background: rgba(255,255,255,0.7);
	border-radius: 5px;
	padding: 0.4375rem 0.875rem;
	font-weight: 600;
	font-size: 1rem;
	color: #000;
	display: inline-block;
	margin-bottom: 0.5rem;
`;

const BoxDesc = styled.div`
	font-size: 1rem;
	color: rgba(255,255,255,0.7);
	line-height: 2rem;
	p {
		margin: 0 0 0 0;
		font-weight: 200;
		font-size: 1rem;
		line-height: 2rem;
		position: relative;
		padding-left: 1.1em;
		&::before {
			content: '·';
			position: absolute;
			left: 0;
			top: 0;
			color: rgba(255,255,255,0.7);
			font-size: 2em;
			line-height: inherit;
		}
		&.red {
			color: #F26060;
			font-weight: 500;
			&::before {
				content: '';
			}
		}
		@media (max-width: 768px) {
			font-size: 0.875rem;
		}
	}
`;

const NaverReserveButton = styled.a`
	${flexCenterCenter}
	border: 1px solid #fff;
	border-radius: 50px;
	padding: 1.125rem 2.375rem;
	color: #fff;
	font-size: 1.125rem;
	font-weight: 400;
	font-family: 'pretendard', Arial, sans-serif;
	text-align: center;
	text-decoration: none;
	background: transparent;
	margin: 3.75rem auto;
	width: fit-content;
	cursor: pointer;
	transition: background 0.2s;
	&:hover {
		color: #000;
		font-weight: 600;
		background: #fff;
	}
	@media (max-width: 768px) {
		font-size: 0.875rem;
		padding: 0.875rem 1.5rem;
		margin: 2.5rem auto;
	}
`;
